import React from "react";

// Consistent site-wide treatment for the phrase "Agentic Alpha":
// serif (font-display), italic, brand gold (#E8AA68) — matching Section 3.
export const AA_CLASS = "font-display text-[#D1633D]";

export const renderAA = (text) =>
  String(text)
    .split(/(Agentic Alpha)/g)
    .map((part, i) =>
      part === "Agentic Alpha" ? (
        <span key={i} className={AA_CLASS}>
          {part}
        </span>
      ) : (
        <React.Fragment key={i}>{part}</React.Fragment>
      )
    );
